export default __webpack_public_path__ + "static/media/logoHeader-new.89f06ae0.png";